import {call, ForkEffect, put, select, takeLatest} from 'redux-saga/effects';
import {IPresentation} from '../../incase-domain/presentation';
import {patchPresentationRunFile} from '../../service/presentation.service';
import {applyRulesToPresentation} from '../../service/slide.service';
import {updatePresentationAction} from '../actions/dashboard.actions';
import {savePresentationRunFileAction, updatePresentationRunFileAction} from '../actions/runfile.actions';
import {CLOCK_TICK} from '../actions/types/chalkBoardElements.actions.types';
import {
    ISavePresentationRunFileActionType,
    REMOVE_CURRENT_SLIDE_DRAWING,
    SAVE_PRESENTATION_RUN_FILE,
} from '../actions/types/runfile.actions.types';
import {AppState} from '../reducer';
import {getRunFileVars} from './utils/runfile.saga.utils';
import {updateTimerAction} from '../actions/timer.actions';

export function* savePresentationRunFileSaga(action: ISavePresentationRunFileActionType): unknown {
    const {runFile} = action;
    const state: AppState = yield select();
    const {fullPresentation} = state.presentationReducer;
    const previousRunFile = state.runFileReducer.runFile;
    const {timeElapsed} = state.timerReducer;

    const customVars = runFile.customVars ? {...runFile.customVars, ...getRunFileVars()} : getRunFileVars();
    const runfileWithVars = {...runFile, customVars, timeElapsed};
    yield put(updatePresentationRunFileAction(runfileWithVars));

    if (fullPresentation) {
        const presentationWithRules: IPresentation = applyRulesToPresentation(fullPresentation, runfileWithVars);
        yield put(updatePresentationAction(presentationWithRules));
    }

    yield call(patchPresentationRunFile, previousRunFile, runfileWithVars);
}

export function* removeCurrentSlideDrawingSaga(): unknown {
    const state: AppState = yield select();
    const {currentSlideIndex} = state.presentationReducer;
    const {runFile} = state.runFileReducer;
    const newSlideDrawLines = [...(runFile.slideDrawLines || [])];
    newSlideDrawLines[currentSlideIndex] = [];

    const newRunFile = {...runFile, slideDrawLines: newSlideDrawLines};
    yield put(savePresentationRunFileAction(newRunFile));
}

export function* clockTickSaga(): unknown {
    const state: AppState = yield select();
    const {runFile} = state.runFileReducer;
    const {timeElapsed} = state.timerReducer;
    const gameClock = state.presentationReducer.loadedPresentation?.gameConfig.gameClock;

    if (gameClock) {
        const newTimeElapsed = (timeElapsed || 0) + 1;
        const gameSeconds = gameClock * 60;

        if (newTimeElapsed <= gameSeconds) {
            yield put(updateTimerAction(newTimeElapsed));
            // update runfile every 60 seconds with time elapsed
            if (newTimeElapsed % 60 === 0) {
                yield put(savePresentationRunFileAction({...runFile, timeElapsed: newTimeElapsed}));
            }
        }
    }
}

export function* watchRunFileSaga(): Generator<ForkEffect<never>, void> {
    yield takeLatest(SAVE_PRESENTATION_RUN_FILE, savePresentationRunFileSaga);
    yield takeLatest(REMOVE_CURRENT_SLIDE_DRAWING, removeCurrentSlideDrawingSaga);
    yield takeLatest(CLOCK_TICK, clockTickSaga);
}
